import LocalStorageUtil from '@/utils/LocalStorageUtil'

class AuthUtil {
    static _tokenKey: string = 'token'
    static _userInfoKey: string = 'userInfo'

    /**
     * @returns {string}
     */
    static getToken(): string {
        return LocalStorageUtil.getItem(this._tokenKey)
    }

    static getUserInfo(): object {
        return LocalStorageUtil.getItem(this._userInfoKey)
    }

    static getTokenWithBearerPrefix(): string | null {
        const token = AuthUtil.getToken()
        if (!token) {
            return null;
        }
        return `Bearer ${token}`
    }

    static setToken(data: string) {
        LocalStorageUtil.setItem(this._tokenKey, data)
    }

    static setUserInfo(data: object) {
        LocalStorageUtil.setItem(this._userInfoKey, data)
    }


    static removeToken() {
        LocalStorageUtil.removeItem(this._tokenKey)
    }

    static removeUserInfo(){
        LocalStorageUtil.removeItem(this._userInfoKey)
    }

    static removeAuth() {
        this.removeToken()
        this.removeUserInfo()
    }

}

export default AuthUtil